module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.loaded === 'true') ? _c('span', [(_vm.page.better_featured_image != null) ? _c('main', {
    staticClass: "col-xs-12 npd"
  }, [_c('img', {
    attrs: {
      "src": _vm.page.better_featured_image.media_details.sizes['1440x446'].source_url,
      "alt": "",
      "width": "100%"
    }
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "col-xs-12 info-locutor"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.title.rendered)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content.rendered)
    }
  })])]), _vm._v(" "), _vm._l((_vm.page_childrens), function(subpage) {
    return (_vm.loaded_childrens == 'true') ? [(subpage.acf.template == 'formulario') ? _c('page_formulario', {
      attrs: {
        "pagina": subpage
      }
    }) : _vm._e(), _vm._v(" "), (subpage.acf.template == 'iconos') ? _c('page_iconos', {
      staticClass: "valor__item",
      attrs: {
        "pagina": subpage
      }
    }) : _vm._e(), _vm._v(" "), (subpage.acf.template == 'historia') ? _c('page_historia', {
      staticClass: "contenido-anho",
      attrs: {
        "pagina": subpage
      }
    }) : _vm._e(), _vm._v(" "), (subpage.acf.template == 'pioneros') ? _c('page_pioneros', {
      staticClass: "col-xs-12 npd pioneros__item",
      attrs: {
        "pagina": subpage
      }
    }) : _vm._e(), _vm._v(" "), (subpage.acf.template == 'opiniones') ? _c('page_opiniones', {
      staticClass: "item laopinion",
      attrs: {
        "pagina": subpage
      }
    }) : _vm._e(), _vm._v(" "), (subpage.acf.template == 'mapa') ? _c('page_mapa', {
      staticClass: "col-xs-12 npd flex-centermid mapa",
      attrs: {
        "pagina": subpage
      }
    }) : _vm._e()] : _vm._e()
  }), _vm._v(" "), _c('versiculosdeldia')], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ff15dd1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page.vue
// module id = 142
// module chunks = 0